var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4fddc6;}.cls-2,.cls-3{fill:#a06aff;}.cls-2{opacity:0.19;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67,
    cy: 67,
    r: 67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,91.89a3.92,3.92,0,0,0,6.69,2.77L65.45,73.92,86.19,94.66a3.92,3.92,0,1,0,5.54-5.54L71,68.38,91.73,47.65a3.92,3.92,0,1,0-5.54-5.54L65.45,62.84,44.72,42.11a3.92,3.92,0,0,0-5.54,5.54L59.91,68.38,39.18,89.12A3.91,3.91,0,0,0,38,91.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.82,86.35l-47-47a3.92,3.92,0,0,0-5.54,5.54l47,47a3.92,3.92,0,1,0,5.54-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.81,91.89l47-47a3.92,3.92,0,1,0-5.54-5.54l-47,47a3.92,3.92,0,1,0,5.54,5.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.f0efb018a7ee09cf9b37ebb43790c574.svg";
export { ForwardRef as ReactComponent };